import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHouseInfo = async (houseId) => {
  return await request.get(
    `/HousingStock/house/${houseId}/info`,
    {},
    'При загрузке информации о доме произошла ошибка',
    {}
  );
};

const useHouseInfo = (houseId, options = {}) =>
  useQuery(getQueryKeys.houseInfo(houseId), () => getHouseInfo(houseId), {
    placeholderData: {},
    enabled: Boolean(houseId),
    ...options,
  });

export default useHouseInfo;
